export const ADD_STUDENT_REQUEST = "ADD_STUDENT_REQUEST";
export const ADD_STUDENT_SUCCESS = "ADD_STUDENT_SUCCESS";
export const ADD_STUDENT_FAIL = "ADD_STUDENT_FAIL";

export const GET_STUDENT_REQUEST = "GET_STUDENT_REQUEST";
export const GET_STUDENT_SUCCESS = "GET_STUDENT_SUCCESS";
export const GET_STUDENT_FAIL = "GET_STUDENT_FAIL";

export const GET_BATCH_STUDENT_REQUEST = "GET_BATCH_STUDENT_REQUEST";
export const GET_BATCH_STUDENT_SUCCESS = "GET_BATCH_STUDENT_SUCCESS";
export const GET_BATCH_STUDENT_FAIL = "GET_BATCH_STUDENT_FAIL";

export const UPDATE_STUDENT_REQUEST = "UPDATE_STUDENT_REQUEST";
export const UPDATE_STUDENT_SUCCESS = "UPDATE_STUDENT_SUCCESS";
export const UPDATE_STUDENT_FAIL = "UPDATE_STUDENT_FAIL";

export const DELETE_STUDENT_REQUEST = "DELETE_STUDENT_REQUEST";
export const DELETE_STUDENT_SUCCESS = "DELETE_STUDENT_SUCCESS";
export const DELETE_STUDENT_FAIL = "DELETE_STUDENT_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS";


// export const ADD_STUDENT_REQUEST = "ADD_STUDENT_REQUEST";
// export const ADD_STUDENT_SUCCESS = "ADD_STUDENT_SUCCESS";
// export const ADD_STUDENT_FAIL = "ADD_STUDENT_FAIL";

// export const GET_STUDENTS_REQUEST = "GET_STUDENTS_REQUEST";
// export const GET_STUDENTS_SUCCESS = "GET_STUDENTS_SUCCESS";
// export const GET_STUDENTS_FAIL = "GET_STUDENTS_FAIL";

// export const GET_BATCH_STUDENTS_REQUEST = "GET_BATCH_STUDENTS_REQUEST";
// export const GET_BATCH_STUDENT_SUCCESS = "GET_BATCH_STUDENT_SUCCESS";
// export const GET_BATCH_STUDENT_FAIL = "GET_BATCH_STUDENT_FAIL";

// export const UPDATE_STUDENT_REQUEST = "UPDATE_STUDENT_REQUEST";
// export const UPDATE_STUDENT_SUCCESS = "UPDATE_STUDENT_SUCCESS";
// export const UPDATE_STUDENT_FAIL = "UPDATE_STUDENT_FAIL";

// export const DELETE_STUDENT_REQUEST = "DELETE_STUDENT_REQUEST";
// export const DELETE_STUDENT_SUCCESS = "DELETE_STUDENT_SUCCESS";
// export const DELETE_STUDENT_FAIL = "DELETE_STUDENT_FAIL";

// export const CLEAR_ERRORS = "CLEAR_ERRORS";
